import React from "react";
import './App.css';
import handleStateChange from './App';

class TableRow extends React.Component {
    constructor(props) {
        super(props);
    };

    handleClick(name){
        console.log("click detected");
        console.log(name);
        document.getElementById("donationReciever").innerText = name;
    }

    render() {
        return (
            <tr className="hover:bg-cyan-100" onClick={() => this.handleClick(this.props.name)}>
                <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                        <div className="flex-shrink-0 h-10 w-10">
                            <img className="h-10 w-10 rounded-full"
                                 src={this.props.imgsrc}/>
                        </div>
                        <div className="ml-4">
                            <a href={this.props.website}>
                            <div className="text-sm font-medium text-gray-900 hover:text-cyan-900">
                                {this.props.name}
                            </div>
                            </a>
                        </div>
                    </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    { this.props.category }
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {this.props.info}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">

                    <div>
                        {
                            this.props.status === "Verified" ? (
                                <span
                                    className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                {this.props.status}
                    </span>
                            ) : (
                                <span
                                    className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">
                {this.props.status}
                    </span>
                            )
                        }
                    </div>

                </td>
            </tr>

        )
    }
}

export default TableRow;
